import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10967aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "mfa-modal" }
const _hoisted_4 = { class: "mfa-button-modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Reset authentication code")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Multifactor Code", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "close", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button is-primary btn-login ml-2",
  "data-test": "btn-submit-reset"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "check")
], -1))
const _hoisted_10 = { class: "mfa-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Multifactor Authentication", -1))
const _hoisted_12 = { class: "mfa-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "teleperformance-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://devcol.blob.core.windows.net/external-images/logo.svg",
    alt: "Teleperformance-logo",
    "data-test": "tp-logo"
  })
], -1))
const _hoisted_14 = {
  key: 0,
  class: "mfa-info-content",
  "data-test": "reset-form"
}
const _hoisted_15 = {
  key: 0,
  class: "mfa-qr-content"
}
const _hoisted_16 = { class: "mfa-qr" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<article class=\"mfa-welcome\" data-v-10967aae><p data-v-10967aae>Download any authentication app from your store.<br data-v-10967aae><span data-v-10967aae>Sync the app with your account scanning this QR code.</span></p><div class=\"mfa-google-play\" data-v-10967aae><div class=\"google-logo\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/Google_Play_Store_badge_EN.svg\" alt=\"Google Play\" data-v-10967aae></div><div class=\"app-container\" data-v-10967aae><a href=\"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=en&amp;gl=US\" target=\"_blank\" data-test=\"gplay-google-authenticator-a\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/google-authenticator.svg\" alt=\"Google Authenticator\" data-test=\"gplay-google-authenticator-img\" data-v-10967aae></a><a href=\"https://play.google.com/store/apps/details?id=com.azure.authenticator&amp;hl=en_US\" target=\"_blank\" data-test=\"gplay-ms-authenticator-a\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/msa.png\" alt=\"Microsoft Authenticator\" data-test=\"gplay-ms-authenticator-img\" data-v-10967aae></a><a href=\"https://play.google.com/store/apps/details?id=com.authy.authy\" target=\"_blank\" data-test=\"gplay-authy-a\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/authy.svg\" alt=\"Authy\" data-test=\"gplay-authy-img\" data-v-10967aae></a></div></div><div class=\"mfa-app-store\" data-v-10967aae><div class=\"appstore-logo\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/app-store.svg\" alt=\"App Store\" data-v-10967aae></div><div class=\"app-container\" data-test=\"appStore-container\" data-v-10967aae><a href=\"https://apps.apple.com/es/app/google-authenticator/id388497605\" target=\"_blank\" data-test=\"appstore-google-authenticator-a\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/google-authenticator.svg\" alt=\"Google Authenticator\" data-test=\"appstore-google-authenticator-img\" data-v-10967aae></a><a href=\"https://apps.apple.com/us/app/microsoft-authenticator/id983156458\" target=\"_blank\" data-test=\"appstore-ms-authenticator-a\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/msa.png\" alt=\"Microsoft Authenticator\" data-test=\"appstore-ms-authenticator-img\" data-v-10967aae></a><a href=\"https://apps.apple.com/es/app/authy/id494168017\" target=\"_blank\" data-test=\"appstore-authy-a\" data-v-10967aae><img src=\"https://devcol.blob.core.windows.net/external-images/authy.svg\" alt=\"Authy\" data-test=\"appstore-authy-img\" data-v-10967aae></a></div></div></article>", 1)
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "token" }, [
  /*#__PURE__*/_createTextVNode("Please enter the "),
  /*#__PURE__*/_createElementVNode("b", null, "six digits code"),
  /*#__PURE__*/_createTextVNode(" generated on your authenticator App:")
], -1))
const _hoisted_20 = { class: "mfa-button-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mfa-error has-text-danger" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "arrow_forward", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "mfa-recover"
}
const _hoisted_25 = {
  key: 1,
  class: "mfa-info-content",
  "data-test": "reset-sent"
}
const _hoisted_26 = { class: "mfa-msg-reset" }
const _hoisted_27 = { class: "buttons mt-4" }
const _hoisted_28 = { class: "notifications" }
const _hoisted_29 = {
  key: 0,
  class: "notification is-danger is-light"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "delete" }, null, -1))
const _hoisted_31 = { class: "buttons mt-4" }
const _hoisted_32 = {
  key: 1,
  class: "notification is-danger is-light",
  "data-test": "notification-error"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal", {'is-active': _ctx.showReset}]),
      id: "modal"
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            id: "frmReset",
            name: "frmReset",
            class: "mfa-frm-reset",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, [
                _createTextVNode("We will send an email to your account "),
                _createElementVNode("b", null, _toDisplayString(_ctx.mfa.username), 1),
                _createTextVNode(" to reset the "),
                _hoisted_6,
                _createTextVNode(". ")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button is-light btn-login",
                  "data-test": "btn-close-reset",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showReset = false))
                }, _hoisted_8),
                _hoisted_9
              ])
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("button", {
        class: "modal-close is-large",
        "aria-label": "close",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showReset = false))
      })
    ], 2),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("section", _hoisted_12, [
        _hoisted_13,
        (!_ctx.mfaReset)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.mfa.qr)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("article", _hoisted_16, [
                      _createElementVNode("img", {
                        src: _ctx.mfa.qr,
                        alt: "qr",
                        "data-test": "qr-img"
                      }, null, 8, _hoisted_17)
                    ]),
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Form, {
                class: "mfa-form",
                id: "mfaForm",
                name: "mfaForm",
                onSubmit: _ctx.verify
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "token",
                    id: "token",
                    rules: "required|mfa",
                    autocomplete: "off",
                    required: "",
                    minlength: "1",
                    maxlength: "6",
                    modelValue: _ctx.token,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.token) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_ErrorMessage, {
                      name: "token",
                      class: "has-text-danger",
                      "data-test": "validation-error"
                    }),
                    _hoisted_21,
                    _createElementVNode("button", {
                      class: _normalizeClass(["button is-primary btn-login", {'is-loading': _ctx.loadingMFA}]),
                      "data-test": "send-token"
                    }, _hoisted_23, 2)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"]),
              (!_ctx.mfa.qr)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showReset = true))
                    }, "I want to recover my authentication code")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createTextVNode(" We sent an email to your account, please review and follow the instructions to reset your MFA. Once you complete the process, please reload this page. "),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    class: "button is-primary mb-0 has-text-weight-semibold",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.go()))
                  }, " Reload ")
                ])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      (_ctx.mfaError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createTextVNode(" Could not load MFA data. "),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: "button is-danger is-light is-outlined mb-0 has-text-weight-semibold",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({name: 'Applications'})))
              }, " Go back ")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_ctx.error === 401)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Invalid MFA token"))
              : _createCommentVNode("", true),
            (_ctx.error === 500)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Could not verify MFA token"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}